import { isAndroid, isWeb } from '@/constants/environment'
import { ConnectionType } from '@/features/print/constants'

const connectionSupportMap: Record<ConnectionType, boolean> = {
    [ConnectionType.Network]: !isWeb,
    [ConnectionType.SunmiDefault]: isAndroid,
}

export const ConnectionSupport = {
    isSupportedConnectionType: (type: ConnectionType): boolean => {
        return connectionSupportMap[type] || false
    },
    getSupportedConnectionTypes: (): ConnectionType[] => {
        return (Object.keys(connectionSupportMap) as ConnectionType[]).filter(
            (type) => connectionSupportMap[type]
        )
    },
}
